import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  width: 100%;
  min-width: ${({ mwidth }) => mwidth};
  @media only screen and (max-width: 768px) {
    max-width: 100% !important;
  }
`;

const ErrorMessage = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: red;
  height: ${(props) => props.error};
  transition: 300ms;
`;

const StyledLabel = styled.label`
  font-weight: 600;
  color: var(--header-text);
`;

export const InputSelect = ({
  name,
  label,
  options,
  optionData,
  errorMessage,
  defaultValue,
  setDefaultValue,
  control,
  placeholder,
  valueView,
  mwidth = "none",
  value,
  readOnly = false,
  required = true,
  customRef = null,
  style,
}) => {
  const arrOptions =
    optionData !== undefined
      ? optionData.flat().filter((option) => option.titleNameArr === name)
      : options;
  return (
    <Container mwidth={mwidth} style={style}>
      <StyledLabel>{label}</StyledLabel>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field, field: { onChange, value = defaultValue } }) => (
          <ReactSelect
            {...field}
            ref={customRef}
            options={arrOptions}
            placeholder={valueView || placeholder}
            value={
              defaultValue
                ? arrOptions.find((c) => c.id || c.value === defaultValue)
                : arrOptions.find((c) => c.id || c.value === value)
            }
            onChange={(val) => {
              onChange(val?.value);
              defaultValue && setDefaultValue(val?.value);
            }}
            isDisabled={readOnly}
          />
        )}
        rules={{ required }}
      />
      <ErrorMessage>
        {errorMessage === "required" ? "Campo obligatorio" : ""}
      </ErrorMessage>
    </Container>
  );
};
